/**
 * Page heading: 22 px / 800 / −0.5 letter-spacing, muted sub-line, right-hand action
 * slot. Prototype: docs/HRMS.jsx line 559-569.
 *
 * Every screen renders exactly one, and it is the page's `<h1>`.
 */
import type { ReactNode } from "react";
import "./ui.css";

export interface SectionTitleProps {
  children: ReactNode;
  sub?: ReactNode;
  /** Actions aligned to the right edge — view toggles, primary buttons, pickers. */
  right?: ReactNode;
  id?: string;
}

export function SectionTitle({ children, sub, right, id }: SectionTitleProps) {
  return (
    <div className="ui-section-title">
      <div className="ui-section-title__main">
        <h1 className="ui-section-title__h" id={id}>{children}</h1>
        {sub ? <p className="ui-section-title__sub">{sub}</p> : null}
      </div>
      {right}
    </div>
  );
}

export default SectionTitle;
